export default function joinNames(arr, andWord = 'og') {
  const copy = arr.slice(0)

  if (copy.length < 2) {
    return copy.join('')
  }
  const lastTwo = copy.slice(-2)
  copy.splice(arr.length - 2, arr.length, lastTwo.join(` ${andWord} `))

  return copy.join(', ')
}
